@if(isLoading()){
<div class="spiner-container">
  <mat-progress-spinner class="spiner" mode="indeterminate" color="primary" diameter="50" strokeWidth="5">
  </mat-progress-spinner>
</div>
}